import { OrderSetupStatusEnum } from "Infrastructure/Api/Api";
import { useOrderSetupIdQuery } from "Settings/Modules/OrderSetup/Api/Query/useOrderSetupIdQuery";
import { OrderSetupCreateButton } from "Settings/Modules/OrderSetup/Components/CreateButton";
import { OrderSetupEditForm } from "Settings/Modules/OrderSetup/Components/Form/EditForm";
import { OrderSetupList } from "Settings/Modules/OrderSetup/Components/OrderSetupList";
import { OrderSetupCopyButton } from "Settings/Modules/OrderSetup/Widgets/OrderSetupCopyButton";
import {
	Box,
	CircularProgress,
	Divider,
	Stack,
	type Theme,
	useMediaQuery,
} from "@mui/material";
import { OrderSetupDeleteWidget } from "./OrderSetupDeleteWidget";

type OrderSetupEditWidgetProps = {
	marketId?: number;
	verticalId?: number;
	orderSetupId?: number;
};

export function OrderSetupEditWidget({
	marketId,
	verticalId,
	orderSetupId,
}: OrderSetupEditWidgetProps) {
	const { data: orderSetup, isLoading } = useOrderSetupIdQuery(orderSetupId);

	const isSmallScreen = useMediaQuery((theme: Theme) =>
		theme.breakpoints.down("md"),
	);

	return (
		<Stack
			flexDirection={{ xs: "column", md: "row" }}
			columnGap={3}
			spacing={2}
			p={2}
			pr={0}
			minHeight={"80vh"}
			maxHeight={"80vh"}
			position="relative"
			overflow={"hidden"}
			alignItems={"stretch"}
		>
			<Box width={{ xs: "100%", md: "320px" }}>
				<Stack
					spacing={2}
					justifyContent={"space-between"}
					flexGrow={0}
					height="100%"
					overflow={"overlay"}
				>
					{verticalId && marketId && (
						<OrderSetupList
							marketId={marketId}
							verticalId={verticalId}
							orderSetupId={orderSetupId}
						/>
					)}
					{marketId && verticalId && (
						<OrderSetupCreateButton
							verticalId={verticalId}
							marketId={marketId}
						/>
					)}
				</Stack>
			</Box>
			<Divider
				orientation={isSmallScreen ? "horizontal" : "vertical"}
				flexItem
			/>
			{isLoading ? (
				<Stack
					width="100%"
					flexGrow={1}
					alignItems="center"
					justifyContent="center"
				>
					<CircularProgress />
				</Stack>
			) : (
				<Stack width="100%" flexGrow={0}>
					<Stack spacing={2} direction="row" alignSelf="flex-end">
						{orderSetup &&
							marketId &&
							verticalId &&
							orderSetup.status !== OrderSetupStatusEnum.deployed &&
							!orderSetup.isLocked && (
								<OrderSetupDeleteWidget
									orderSetup={orderSetup}
									marketId={marketId}
									verticalId={verticalId}
								/>
							)}
						{orderSetup && marketId && verticalId && (
							<OrderSetupCopyButton
								marketId={marketId}
								verticalId={verticalId}
								orderSetup={orderSetup}
							/>
						)}
					</Stack>
					{orderSetup && <OrderSetupEditForm orderSetup={orderSetup} />}
				</Stack>
			)}
		</Stack>
	);
}
